import { brandBgEntityRaw } from "./brand-bg-entity-raw";
import { brandCaptionLowerThirdEntityRaw } from "./brand-caption-lower-third-entity-raw";
import { brandEntityId } from "./brand-entity-id";
import { brandIsDefault } from "./brand-is-default";
import { brandLogoEntityRaw } from "./brand-logo-entity-raw";
import { brandOverlayEntityRaw } from "./brand-overlay-entity-raw";
import { brandTitle } from "./brand-title";

export const brandEntityRaw = {
  type: "object",
  required: [
    "id",
    "title",
    "isDefault",
    "logos",
    "bgs",
    "overlays",
    "captionLowerThirds"
  ],
  properties: {
    id: brandEntityId,
    title: brandTitle,
    isDefault: brandIsDefault,
    logos: {
      type: "array",
      minItems: 0,
      maxItems: Number.MAX_SAFE_INTEGER,
      items: brandLogoEntityRaw
    },
    bgs: {
      type: "array",
      minItems: 0,
      maxItems: Number.MAX_SAFE_INTEGER,
      items: brandBgEntityRaw
    },
    overlays: {
      type: "array",
      minItems: 0,
      maxItems: Number.MAX_SAFE_INTEGER,
      items: brandOverlayEntityRaw
    },
    captionLowerThirds: {
      type: "array",
      minItems: 0,
      maxItems: Number.MAX_SAFE_INTEGER,
      items: brandCaptionLowerThirdEntityRaw
    }
  },
  additionalProperties: false
};
